import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isAnalyticsAllowed } from "@/lib/consent";

const getOrCreateId = (storage: Storage, key: string) => {
  const existing = storage.getItem(key);
  if (existing) return existing;

  const id = window.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  storage.setItem(key, id);
  return id;
};

/**
 * Analytics scripts are initialized once in index.html. Route changes only
 * update Clarity's page context with a stable anonymous visitor/session ID.
 */
export const AnalyticsTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    try {
      if (!window.clarity) return;

      if (!isAnalyticsAllowed()) {
        window.clarity("consent", false);
        return;
      }

      const visitorId = getOrCreateId(window.localStorage, "photosynthetic_clarity_visitor_id");
      const sessionId = getOrCreateId(window.sessionStorage, "photosynthetic_clarity_session_id");
      const pageId = `${pathname}${search}` || "/";

      window.clarity("consentv2", {
        ad_Storage: "granted",
        analytics_Storage: "granted",
      });
      window.clarity("identify", visitorId, sessionId, pageId);
      window.clarity("set", "page_path", pageId);
    } catch (e) {}
  }, [pathname, search]);

  return null;
};
